// Debug logging for the search widget (#8173).
//
// All non-error widget console output is gated behind data-vo-search-debug="true"
// on an embed element, so a production embed is silent by default while a site
// owner can opt into verbose logs for troubleshooting. Error-level logging
// (console.error) is never gated -- failures must always be visible.

let debugEnabled = null;

function detectDebug() {
  if (typeof document === 'undefined' || typeof document.querySelector !== 'function') {
    return false;
  }
  return !!document.querySelector('[data-vo-search-debug="true"]');
}

/**
 * isSearchDebugEnabled reports whether debug logging is on, detecting the embed
 * attribute once and caching the result for the page load.
 * @returns {boolean}
 */
export function isSearchDebugEnabled() {
  if (debugEnabled === null) {
    debugEnabled = detectDebug();
  }
  return debugEnabled;
}

/**
 * debugLog forwards to console.log only when debug is enabled.
 * @param {...*} args
 */
export function debugLog(...args) {
  if (isSearchDebugEnabled()) {
    console.log(...args);
  }
}

/**
 * debugWarn forwards to console.warn only when debug is enabled.
 * @param {...*} args
 */
export function debugWarn(...args) {
  if (isSearchDebugEnabled()) {
    console.warn(...args);
  }
}

/** resetSearchDebug clears the cached detection. Exported for tests. */
export function resetSearchDebug() {
  debugEnabled = null;
}
